module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/9200459659/introduction01-5e0d21eb3c7b0c09080a6ea7bce79ff8.png";